import type { ComponentProps } from 'react';

import { twMerge } from '@/tailwind-merge.config';

// used code from /assets/svg/Icon/CloseButton.svg & CloseButtonHover.svg (on hover is bigger)
export const IconCloseButton = ({ className, ...props }: ComponentProps<'svg'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      className={twMerge('group/close-btn', className)}
      {...props}
    >
      <rect
        x="0.5"
        y="0.5"
        width="44"
        height="44"
        className="stroke-black stroke-1 group-hover/close-btn:stroke-[3]"
      />
      <path
        d="M11 11L33.9992 34"
        className="stroke-black stroke-1 group-hover/close-btn:stroke-[3]"
        strokeLinecap="round"
      />
      <path
        d="M34 11L11.0008 34"
        className="stroke-black stroke-1 group-hover/close-btn:stroke-[3]"
        strokeLinecap="round"
      />
    </svg>
  );
};
